module.exports = __webpack_public_path__ + "img/shop-feature-chat.f646a482.png";